import { Cache } from './src/lib/Cache';

const filterCache = new Cache(15);
const invoiceCache = new Cache(6);

export { filterCache, invoiceCache };
